module.exports = __webpack_public_path__ + "img/czcb-bank.dde9ab3.svg";